import { ADVISOR_SESSION_FRAGMENT } from '@src/gql/fragments/AdvisorSessionFragment'
import { gql } from '@src/lib/gql'

export const ADVISOR_SESSION = gql`
  query AdvisorSession($advisorSessionId: String!) {
    advisorSession(advisorSessionId: $advisorSessionId) {
      ...AdvisorSessionFragment
      ics
      boardEngagement {
        id
        advisorEngagementId
        advisorUserId
        statusKey
      }
    }
  }
  ${ADVISOR_SESSION_FRAGMENT}
`

/** Room + post-confirm chat. Extra fields require local schema after P2-9. */
export const ADVISOR_SESSION_ROOM = gql`
  query AdvisorSessionRoom($advisorSessionId: String!) {
    advisorSession(advisorSessionId: $advisorSessionId) {
      ...AdvisorSessionFragment
      chatThreadId
      chatThread {
        id
        threadId
      }
      boardEngagement {
        id
        advisorEngagementId
        advisorUserId
        isAI
        chatThreadId
      }
    }
  }
  ${ADVISOR_SESSION_FRAGMENT}
`

export const ADVISOR_SESSION_MEDIA = gql`
  query AdvisorSessionMedia($advisorSessionId: String!) {
    advisorSession(advisorSessionId: $advisorSessionId) {
      advisorSessionId
      recordingPartyExpiresAt
      recording
      transcript
    }
  }
`
